export default __webpack_public_path__ + "beta-maps-guides-migrate-3d-terrain-1200-488cf8d6214dc304f930d5eaae9cd32f.png";